import React from "react";
import { useParams } from "react-router-dom"; // Import useParams
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import PortfolioData from "../Data/PortfolioData";
import "./PortfolioDetail.css";
import Contact from "../Components/Contact";
import { FaArrowUpRightFromSquare } from "react-icons/fa6";

const DetailPage = () => {
  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { id } = useParams();
  const portItem = PortfolioData.find((item) => item.title === id);

  document.title = `${portItem.title} - Rizatzmi`;

  return (
    <>
      <Navbar />
      <section className="Detail-Section">
        <div className="Detail-Content">
          <h1 className="Detail-Title">{portItem.title}</h1>
          <img src={portItem.img} alt="" className="Detail-Image" />
          <p className="Paragraph">{portItem.summary}</p>
          <img src="{}" alt="" className="Paragraph-Image" />
          <h1 className="Subtitle">
            The <span>Problem</span>
          </h1>
          <p className="Paragraph">{portItem.problem}</p>
          <img src="{}" alt="" className="Paragraph-Image" />
          <h1 className="Subtitle">
            The <span>Goal</span>
          </h1>
          <p className="Paragraph">{portItem.goal}</p>
          <img src="{}" alt="" className="Paragraph-Image" />
          <h1 className="Subtitle">
            The <span>Solution</span>
          </h1>
          <p className="Paragraph">{portItem.solution}</p>
          <img src="{}" alt="" className="Paragraph-Image" />
          <h1 className="Subtitle">
            The <span>Work</span>
          </h1>
          <p className="Paragraph">{portItem.work}</p>
          <img src="{}" alt="" className="Paragraph-Image" />
          <h1 className="Subtitle">
            The <span>Result</span>
          </h1>
          <p className="Paragraph">{portItem.result}</p>
          <img src="{}" alt="" className="Paragraph-Image" />
          <a
            href={portItem.link}
            target="_blank"
            rel="noopener noreferrer"
            className="Live"
          >
            Live <FaArrowUpRightFromSquare />
          </a>
        </div>
      </section>
      <section className="Contact-Section">
        <Contact />
      </section>
      <Footer />
    </>
  );
};

export default DetailPage;
